import { RootState } from 'store/root-reducer';

export const currentUserSelector = (rootState: RootState) => rootState.auth.user;
export const currentUserPermissionSelector = (rootState: RootState) => rootState.auth.permissions;
export const authSelector = (rootState: RootState) => rootState.auth;
export const rememberSelector = (rootState: RootState) => rootState.auth.isRemember;
export const currentRoleSelector = (rootState: RootState) =>
  currentUserSelector(rootState)?.role.type;
export const isTwoFaVerifiedSelector = (rootState: RootState) => rootState.auth.user?.tfa_verified;
